import * as React from 'react';
import { InclinationMidrangeChart, PVAContainer, LoadingIndicator, PVAContentHeader, PVAContentBody, PVATeamSelect, LoadingIndicatorMini, PVADiamond, PVACharacteristicModal, PVACharacteristicGroupModal } from '../../../components';
import { ReportType } from '../../../enums';
import { ReportDataService, CharacteristicDataService, CharacteristicGroupDataService } from '../../../services';
import { User, CharacteristicGroup, Characteristic, Team, CharacteristicGroupCharacteristic, CharacteristicGroupSubGroup, CharacteristicGroupSubGroupCharacteristic } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { UserStore, FilterStore } from '../../../stores';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

interface TeamReportState {
    orgId: number;
    surveyVersionId: number;
    selectedUserData: any;
    users: User[];
    reportType: ReportType;
    characteristicGroups: CharacteristicGroup[];
    characteristics: Characteristic[];
    loading: boolean;
    teamId: number | undefined;
    miniLoad: boolean;
    groupModalVisible: boolean[];
    // groupModal: boolean[];
    charModalVisible: boolean[];
    // charModal: boolean[];
    open: boolean;
}

interface TeamReportProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class TeamReport extends React.Component<TeamReportProps, TeamReportState> {
    private reportDataService = new ReportDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private stdDev: number = 1.25;

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    constructor(props: TeamReportProps) {
        super(props);

        this.state = {
            orgId: 0,
            surveyVersionId: 0,
            selectedUserData: undefined,
            users: [],
            characteristicGroups: [],
            characteristics: [],
            reportType: ReportType.Standard,
            loading: false,
            teamId: -1,
            miniLoad: false,
            charModalVisible: [],
            groupModalVisible: [],
            open: false
        };
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get team() {
        if (this.props.FilterStore && this.props.FilterStore.team) {
            return this.props.FilterStore.team;
        }
        return null;
    }

    @computed get teamId() {
        return this.props.FilterStore && this.props.FilterStore.teamId;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }
    
    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get teams() {
        if (this.props.FilterStore && this.props.FilterStore.teams) {
            return this.props.FilterStore.teams;
        }
        return [];
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    public update() {

        var updateSurveyVersionID = false;
        if (this.userRole !== 'user') {
            if (this.surveyVersion && this.surveyVersion.id !== this.state.surveyVersionId) {
                this.setState({
                    surveyVersionId: this.surveyVersion.id
                });
                updateSurveyVersionID = true;

                this.characteristicGroupDataService.getAllBySurveyVersion(this.surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                    var groupModalVisible = characteristicGroups.map(x => false);
                    this.setState({
                        groupModalVisible: groupModalVisible,
                        characteristicGroups: characteristicGroups
                    });
                });

                this.characteristicDataService.getAllBySurveyVersion(this.surveyVersion).then((characteristics: Characteristic[]) => {
                    var charModalVisible = characteristics.map(x => false);
                    this.setState({
                        charModalVisible: charModalVisible,
                        characteristics: characteristics
                    });
                });

            }

            if (this.surveyVersion && (this.teamId !== this.state.teamId || updateSurveyVersionID)) {
                this.setState({
                    teamId: this.teamId
                });

                const surveyVersionId = this.surveyVersion.id;

                if (this.team) {
                    this.setState({
                        miniLoad: true
                    });

                    this.reportDataService.getTeamReportData(this.team, surveyVersionId)
                        .then((data: any) => {
                            this.setState(
                                {
                                    selectedUserData: data.entries,
                                    miniLoad: false
                                },
                                this.forceUpdate);
                        })
                        .catch(() => {
                            this.props.notificationService.addError('Error retrieving team report data.');
                            this.setState({miniLoad: false});
                        });
                } else if (this.organization && this.teamId === -100) {
                    this.setState({
                        miniLoad: true
                    });

                    this.reportDataService.getTeamOrganizationReportData(this.organization, surveyVersionId).then((data: any) => {
                        this.setState(
                            {
                                selectedUserData: data.entries,
                                miniLoad: false
                            },
                            this.forceUpdate);
                    })
                    .catch(() => {
                        this.props.notificationService.addError('Error retrieving team report data.');
                        this.setState({miniLoad: false});
                    });
                } else if (this.organization && this.teamId === -200) {
                    this.setState({
                        miniLoad: true
                    });

                    this.reportDataService.getTeamCandidateReportData(this.organization, surveyVersionId).then((data: any) => {
                        this.setState(
                            {
                                selectedUserData: data.entries,
                                miniLoad: false
                            },
                            this.forceUpdate);
                    })
                    .catch(() => {
                        this.props.notificationService.addError('Error retrieving team report data.');
                        this.setState({miniLoad: false});
                    });
                } else if (this.organization && this.teamId === -300) {
                    this.setState({
                        miniLoad: true
                    });

                    this.reportDataService.getTeamFormerEmployeeReportData(this.organization, surveyVersionId).then((data: any) => {
                        this.setState(
                            {
                                selectedUserData: data.entries,
                                miniLoad: false
                            },
                            this.forceUpdate);
                    })
                    .catch(() => {
                        this.props.notificationService.addError('Error retrieving team report data.');
                        this.setState({miniLoad: false});
                    });
                } 

            }
        }
    }

    componentDidMount() {
        this.update();
    }

    public componentWillReact() {
        this.update();
    }

    private GetKeyOverride(key?: string, fallback?: any) {
        if (key && this.props.FilterStore) {
            return this.props.FilterStore.GetKeyOverride(key, fallback || '');
        }
        return fallback;
    }

    teamChange(e: any) {
        if (this.props.FilterStore) {
            var id = Number(e.target.value);
            var team = this.teams.find((t: Team) => {
                return t.id === id;
            });
            if (team) {
                this.props.FilterStore.setTeam(team);
            } else {
                // -100, -200, -300, etc
                this.props.FilterStore.setTeamID(id);
            }
        }
    }

    toggleCharModal(index: number) {
        let { charModalVisible } = this.state;

        charModalVisible[index] = !charModalVisible[index];
        this.setState({ charModalVisible: charModalVisible });
    }

    toggleGroupModal(index: number) {
        let { groupModalVisible } = this.state;

        groupModalVisible[index] = !groupModalVisible[index];
        this.setState({ groupModalVisible: groupModalVisible });
    }

    getGroupModalElement(groupId: number, name: string, core: string, content: string, groupIndex: number) {
        const props = {
            show: this.state.groupModalVisible[groupIndex],
            onHide: this.toggleGroupModal.bind(this, groupIndex),
            title: name,
            core: core,
            content: content,
            step: groupIndex
        };

        return (
            <div key={`Group-Modal-${groupId}`}>
                <PVACharacteristicGroupModal {...props} />
            </div>);
    }

    getModalElement(characteristicId: number, name: string, content: string, index: number, value: number, low: number, high: number, desc: string, group: string, core: string, groupIndex: number) {
        const props = {
            show: this.state.charModalVisible[index],
            onHide: this.toggleCharModal.bind(this, index),
            title: group,
            content: content,
            value: value,
            description: desc,
            core: core,
            step: groupIndex,
            name: name,
            midLow: low,
            midHigh: high,
            allowToggle: this.userPermissions.indexOf('scoreBarColorChange') > -1
        };
        
        return (
            <div key={`Characteristic-Modal-${characteristicId}`}>
                <PVACharacteristicModal {...props} />
            </div>);
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    <li className="options-header">Actions</li>
                    <li className="options-entry">      
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-list-alt" /> <span> Standard Deviation</span>
                        </div>              
                        <select className="form-control" onChange={(e) => { this.stdDev = parseFloat(e.target.value); this.setState({ open: !this.state.open}, this.forceUpdate); }}>
                            <option selected={this.stdDev === 0.5} value={0.5}>STD DEV 0.5</option>
                            <option selected={this.stdDev === 0.75} value={0.75}>STD DEV 0.75</option>
                            <option selected={this.stdDev === 1.0} value={1.0}>STD DEV 1</option>
                            <option selected={this.stdDev === 1.25} value={1.25}>STD DEV 1.25</option>
                            <option selected={this.stdDev === 1.5} value={1.5}>STD DEV 1.5</option>
                        </select>
                    </li>          
                </ul>
        </div>);
    }

    public render() {
        let defaultOptions: any[] = [{
            id: 0,
            value: '- Select -'
        }];
        
        if (!this.props.UserStore!.userRoleIn(['manager', 'user']) || this.userPermissions.indexOf('viewAllUsers') > -1 ) {
            defaultOptions.push({
                id: -100,
                value: 'All Users'
            });
        }
        if (!this.props.UserStore!.userRoleIn(['manager', 'user']) || this.userPermissions.indexOf('viewAllCandidates') > -1 ) {
            defaultOptions.push({
                id: -200,
                value: 'All Candidates'
            });
        }
        if (!this.props.UserStore!.userRoleIn(['manager', 'user']) || this.userPermissions.indexOf('viewAllFormerEmployees') > -1 ) {
            defaultOptions.push({
                id: -300,
                value: 'All Former Employees'
            });
        }

        var charOffset = 0;

        let groupModal: any[] = [];
        let charModal: any[] = [];

        return (
            <div>

                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}
                {this.surveyReportType && <div id={`surveyReportType-${this.surveyReportType.id}`} />}

                <PVAContentHeader>
                    <div className="row">
                        <div className="col-xs-9">
                            <div className="title">
                                {this.GetKeyOverride('teamReport', <span>PVA Team Report<span className="trademark">TM</span></span>)} 
                                <span className="light"> for </span>
                                <PVATeamSelect defaultOptions={defaultOptions} options={this.teams} selected={this.teamId} onChange={(e: any) => { this.teamChange(e); }} />   
                                {this.state.miniLoad && <LoadingIndicatorMini />} 
                            </div>
                        </div>
                        <div className="col-xs-3 text-right">
                            {['superAdmin', 'siteAdmin'].includes(this.userRole) && this.ActionsButton()}
                        </div>
                    </div>
                </PVAContentHeader>

                <PVAContentBody>
                    {this.state.loading && <LoadingIndicator />}
                    {!this.state.loading && this.state.characteristicGroups.filter((group: CharacteristicGroup) => {
                            if (group.characteristicGroupDisplayType !== 'normal') {
                                return false;
                            }
                            if (!group.characteristicGroupCharacteristics || group.characteristicGroupCharacteristics.length === 0) {
                                return false;
                            }
                            if (group.secondaryReportID) {
                                return false;
                            }
                            if (!this.surveyReportType) {
                                return true;
                            }
                            return group.surveyReportTypeID === this.surveyReportType.id;
                        }).map((group: CharacteristicGroup, groupInd: number) => {
                            const aboutText = group.characteristicGroupTexts.find(x => x.textType === 'about');
                            groupModal.push(this.getGroupModalElement(group.id, group.name, group.subtitle, aboutText ? aboutText.value : '', groupInd));

                            const icon = <PVADiamond style={''} step={groupInd + 1} />;
                            
                            const title = (
                                <div>
                                    <div className="title-sub">{group.subtitle}</div>
                                    <span> {group.name}
                                        &nbsp;&nbsp;
                                        <span onClick={this.toggleGroupModal.bind(this, groupInd)} className="glyphicon glyphicon-info-sign icon-button" />
                                    </span>
                                </div>
                            );

                            const content = (
                                <div>
                                    <div className="inclination-table comparison">

                                        <div className="row">
                                            <div className="col-xs-6 col-md-5 col-lg-4">
                                                <div className="cell" />

                                                {
                                                    group.characteristicGroupCharacteristics.sort(this.sortOrder).map((cgc: CharacteristicGroupCharacteristic, charIndex: number) => {
                                                            
                                                            var item = this.state.characteristics.find((c: Characteristic) => {
                                                                return c.id === cgc.characteristicID;
                                                            });
                                                            if (!item) {
                                                                return <div key={`char-${charIndex}`} />;
                                                            }
                                                            
                                                            const helpText = item.characteristicTexts.find(x => x.textType === 'higH_TEXT');
                                                            const description = item.characteristicTexts.find(x => x.textType === 'tooltip');

                                                            let charValue = 0;
                                                            if (this.state.selectedUserData) { 
                                                                const charData = this.state.selectedUserData.find((x: any) => {
                                                                    if (item) {
                                                                        return x.characteristicID === item.id;
                                                                    }
                                                                    return false;
                                                                });
                                                                charValue = charData ? charData.average : 0;
                                                            }

                                                            charModal.push(this.getModalElement(item.id, item.name, helpText ? helpText.value : '', charOffset, charValue, item.midStart, item.midEnd, description ? description.value : '', group.name, group.subtitle, groupInd));
                                                            
                                                            const tooltip = <Tooltip id={`tooltip-${item.name}`}><span dangerouslySetInnerHTML={{ __html: description ? description.value : '' }} /></Tooltip>;
                                                            const text = <OverlayTrigger key={`grid-cell-${charIndex}`} animation={''} delay={0} placement="top" overlay={tooltip}>
                                                                <div className="cell text-left">
                                                                    <span className="characteristic-index">{charOffset + 1} </span>
                                                                    <span onClick={this.toggleCharModal.bind(this, charOffset)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                                                    <span onClick={this.toggleCharModal.bind(this, charOffset)} className="characteristic-title">
                                                                            <b>{item.displayName ? item.displayName : item.name}</b>
                                                                    </span>
                                                                </div>
                                                            </OverlayTrigger>;
                                                            charOffset++;
                                                            return text;
                                                    })
                                                }
                                                
                                                {
                                                    group.characteristicGroupSubGroups.sort(this.sortOrder).map((cgsb: CharacteristicGroupSubGroup, sgIndex: number) => {
                                                        return <React.Fragment key={`sub-group-${sgIndex}`}>
                                                            {
                                                                cgsb.characteristicGroupSubGroupCharacteristics.map((cgsgc: CharacteristicGroupSubGroupCharacteristic, cgsgcIndex: number) => {
                                                                    var item = this.state.characteristics.find((c: Characteristic) => {
                                                                        return c.id === cgsgc.characteristicID;
                                                                    });
                                                                    if (!item) {
                                                                        return <div key={`char-sub-${cgsgcIndex}`} />;
                                                                    }
                                                                    
                                                                    const helpText = item.characteristicTexts.find(x => x.textType === 'higH_TEXT');
                                                                    const description = item.characteristicTexts.find(x => x.textType === 'tooltip');

                                                                    let charValue = 0;
                                                                    if (this.state.selectedUserData) { 
                                                                        const charData = this.state.selectedUserData.find((x: any) => {
                                                                            if (item) {
                                                                                return x.characteristicID === item.id;
                                                                            }
                                                                            return false;
                                                                        });
                                                                        charValue = charData ? charData.average : 0;
                                                                    }

                                                                    charModal.push(this.getModalElement(item.id, item.name, helpText ? helpText.value : '', charOffset, charValue, item.midStart, item.midEnd, description ? description.value : '', group.name, group.subtitle, groupInd));
                                                                    
                                                                    const tooltip = <Tooltip id={`tooltip-${item.name}`}><span dangerouslySetInnerHTML={{ __html: description ? description.value : '' }} /></Tooltip>;
                                                                    const text = <OverlayTrigger key={`grid-cell-sub-${cgsgcIndex}`} animation={''} delay={0} placement="top" overlay={tooltip}>
                                                                        <div className="cell text-left">
                                                                            <span className="characteristic-index">{charOffset + 1} </span>
                                                                            <span onClick={this.toggleCharModal.bind(this, charOffset)} className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                                                            <span onClick={this.toggleCharModal.bind(this, charOffset)} className="characteristic-title">
                                                                                    <b>{item.displayName ? item.displayName : item.name}</b>
                                                                            </span>
                                                                        </div>
                                                                    </OverlayTrigger>;
                                                                    charOffset++;
                                                                    return text;
                                                                })
                                                            }
                                                        </React.Fragment>;
                                                    })
                                                }
                                            </div>
                                            <div className="col-xs-6 col-md-7 col-lg-8">
                                                <div className="bg" />
                                                <div className="cell">
                                                    <div className="row">
                                                        <div className="col-xs-6 text-left">
                                                            <div className="cell">
                                                                <span className="chart-content" style={{ left: -5 }}>Less Pronounced</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-xs-6 text-right">
                                                            <div className="cell">
                                                                <span className="chart-content" style={{ right: 0 }}>More Pronounced</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    group.characteristicGroupCharacteristics.map((cgc: CharacteristicGroupCharacteristic) => {
                                                        return <div className="cell" key={cgc.characteristic ? cgc.characteristic.id : 1}>
                                                            {
                                                                this.state.selectedUserData && this.state.selectedUserData.filter((x: any) => {
                                                                    if (cgc.characteristic) {
                                                                        return x.characteristicID === cgc.characteristic.id;
                                                                    }
                                                                    return false;
                                                                }).map((entry: any, index: number) => {
                                                                    var characteristic = this.state.characteristics.find((c: Characteristic) => {
                                                                        return c.id === cgc.characteristicID;
                                                                    });
                                                                    if (!characteristic) {
                                                                        return <div key={`inclinations-${index}`} />;
                                                                    }
                                                                    return <InclinationMidrangeChart key={`inclinations-${index}`} value={entry.average} midrangeLow={this.minMaxFloor(entry.average - (entry.stdDeviation * this.stdDev))} midrangeHigh={this.minMaxFloor(entry.average + (entry.stdDeviation * this.stdDev))} />;
                                                                })
                                                            }
                                                        </div>;
                                                    })
                                                }
                                                {
                                                    group.characteristicGroupSubGroups.map((cgc: CharacteristicGroupSubGroup, cgcInd: number) => {
                                                        return <React.Fragment key={`cgc-$cgInd}`}>
                                                            {cgc.characteristicGroupSubGroupCharacteristics.map((cgsgc: CharacteristicGroupSubGroupCharacteristic) => {
                                                                return <div className="cell" key={cgsgc.characteristic ? cgsgc.characteristic.id : 1}>
                                                                {
                                                                    this.state.selectedUserData && this.state.selectedUserData.filter((x: any) => {
                                                                        if (cgsgc.characteristic) {
                                                                            return x.characteristicID === cgsgc.characteristic.id;
                                                                        }
                                                                        return false;
                                                                    }).map((entry: any, index: number) => {
                                                                        var characteristic = this.state.characteristics.find((c: Characteristic) => {
                                                                            return c.id === cgsgc.characteristicID;
                                                                        });
                                                                        if (!characteristic) {
                                                                            return <div key={`inclinations-${index}`} />;
                                                                        }
                                                                        return <InclinationMidrangeChart key={`inclinations-${index}`} value={entry.average} midrangeLow={this.minMaxFloor(entry.average - (entry.stdDeviation * this.stdDev))} midrangeHigh={this.minMaxFloor(entry.average + (entry.stdDeviation * this.stdDev))} />;
                                                                    })
                                                                }
                                                            </div>;
                                                            })}
                                                        </React.Fragment>;
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );

                            return (
                                <div key={`group-${groupInd}`}>
                                    <PVAContainer icon={icon} title={title} content={content} id={group.name} />
                                </div>);
                    })}
                    {groupModal}
                    {charModal}
                </PVAContentBody>
            </div>);
    }

    private minMaxFloor(val: number) {
        if (val < 0) {
            return 0;
        }
        if (val > 100) {
            return 100;
        }
        return Math.round(val);
    }

    private sortOrder(a: any, b: any) {
        if (a.sort > b.sort) {
            return 1;
        }
        if (a.sort < b.sort) {
            return -1;
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/team/TeamReport.tsx